import { css } from '@emotion/react'
import { FormControl, VFlow } from 'bold-ui'
import { CheckboxField } from 'components/form'
import { InputMaybe, TipoEstabelecimentoEnum } from 'graphql/types.generated'
import { MetaArray } from 'util/metaPath'

import { tiposEstabelecimento } from '../tipoEstabelecimentoLabels'

export interface TipoEstabelecimentoFieldProps {
  name: MetaArray<InputMaybe<TipoEstabelecimentoEnum>>
  required?: boolean
}

export function TipoEstabelecimentoField(props: TipoEstabelecimentoFieldProps) {
  const { name, required } = props

  return (
    <FormControl label='Tipos de estabelecimento' required={required}>
      <VFlow vSpacing={0.5}>
        {tiposEstabelecimento.map((estabelecimento) => (
          <CheckboxField
            key={estabelecimento.value.toString()}
            name={name}
            label={estabelecimento.label}
            required={required}
            value={estabelecimento.value}
            style={styles.checkbox}
          />
        ))}
      </VFlow>
    </FormControl>
  )
}

const styles = {
  checkbox: css`
    margin: 0 -0.25rem;
  `,
}
